import { testimonialList } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-600 mb-4">
            <i className="ri-sparkling-fill text-[10px]"></i> Opinie
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Co mówią <span className="italic text-primary-500">użytkownicy</span>?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {testimonialList.slice(0, 2).map((t) => (
            <div key={t.name} className="bg-background-50 rounded-2xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-200 block mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{t.text}</p>
            </div>
          ))}

          <div className="relative rounded-2xl overflow-hidden h-full min-h-[240px]">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20European%20woman%20in%20her%20late%20twenties%20with%20genuine%20warm%20smile%20holding%20a%20shopping%20bag%20standing%20in%20a%20bright%20minimalist%20apartment%20interior%20with%20white%20walls%20and%20warm%20wood%20floors%20soft%20natural%20window%20light%20lifestyle%20editorial%20photography%20authentic%20candid%20moment%20scandinavian%20home%20aesthetic%20neutral%20clothing%20high%20detail%20film%20grain&width=600&height=800&seq=testimonial-photo-v2&orientation=portrait"
              alt="Zadowolony użytkownik Kakobuy Spreadsheet"
              title="Kakobuy Spreadsheet – opinia użytkownika"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent">
              <p className="text-background-50 text-sm font-semibold">Karolina M.</p>
              <p className="text-background-50/80 text-xs">Lojalna klientka</p>
            </div>
          </div>

          {testimonialList.slice(2, 5).map((t) => (
            <div key={t.name} className="bg-background-50 rounded-2xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-200 block mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-2 justify-center mt-8 max-w-2xl mx-auto">
          {[1, 2, 3, 4, 5].map((star) => (
            <i key={star} className="ri-star-fill text-primary-400 text-lg"></i>
          ))}
          <span className="text-sm text-foreground-500 ml-2">4.9/5 na podstawie opinii użytkowników</span>
        </div>
      </div>
    </section>
  );
}